import React from 'react';
import PropTypes from 'prop-types';
import Comment from 'assets/icons/Comment';
import { useConversation } from 'hooks/useConversation/useConversation';
import { CHAT_ROUTES } from 'utils/constants/chat';

const ChatOpener = ({ className }) => {
  const { handleGoToRoute, hasUnreadMessages } = useConversation();

  return (
    <div className={className} data-testid="chat-opener">
      <div className="chat-opener">
        <button
          data-testid="chat-opener__button"
          className="chat-opener__button"
          onClick={() => handleGoToRoute(CHAT_ROUTES.CONVERSATIONS_LIST)}
        >
          {hasUnreadMessages && (
            <span
              data-testid="chat-opener__badge"
              className="chat-opener__badge"
            ></span>
          )}
          <Comment className="chat-opener__icon" />
        </button>
      </div>
    </div>
  );
};

ChatOpener.propTypes = {
  className: PropTypes.string,
  badgeNumber: PropTypes.number
};

export default ChatOpener;
